<template>
	<div class="height-100dvh">
		<div id="hideinlaptop" class="mob-back-header d-flex align-items-center">
			<img
				@click="$router.go(-1)"
				class="mr-3"
				src="../../assets/mobile/assprog/mobileBackArrow.svg"
				alt=""
			/>
			Become an Instructor
		</div>
		<main class="resda-main-container w-100">
			<div id="hideinmobile" class="cand-header d-flex mb-2">
				<img
					@click="$router.go(-1)"
					class="mr-3 d-flex pointer"
					src="../../assets/img/homepage/back-arrow-blue.svg"
					alt=""
				/>
				Become an Instructor
			</div>
			<div v-if="selected" class="resda-down-cont max-1825">
				<section class="resda-left-cont">
					<h2 class="fam-mont text-blue fw-M resda-fs-32 mb-0">
						Your Instructor Application Results 🎉
					</h2>
					<h5 class="fam-lato text-darkgrey fw-R resda-fs-20 z-ind-2">
						Congratulations {{ InstructorData[0].candidateInfo.firstName }}
						{{ InstructorData[0].candidateInfo.lastName }}! Based on our
						evaluation, you have been qualified to create courses in the
						following domains:
					</h5>
					<div class="resda-qual-skill">
						<div class="d-flex align-items-center text-blue fw-M">
							<img
								class="mr-2"
								src="../../assets/newdesign/BecomePanelist/qualified-tick.svg"
								alt=""
							/>
							You can take courses for:
						</div>
					</div>
					<div class="resda-scroll">
						<div class="wrapper-scroll">
							<article
								v-for="(cat, i) in InstructorData[0].instructorInfo.categories"
								:key="i"
							>
								{{ cat }}
							</article>
						</div>
					</div>
					<b-button id="hideinmobile" class="candash-addBtn mt-3 w-50" @click="goToDashboard()"
						>Go to dashboard</b-button
					>
					<section id="hideinlaptop" class="resda-back-img-size">
						<img
							class="h-100 w-100"
							src="../../assets/newdesign/BecomePanelist/resda-back.svg"
							alt=""
						/>
					</section>
				</section>
				<section id="hideinmobile" class="resda-back-img-size">
					<img
						class="h-100 w-100"
						src="../../assets/newdesign/BecomePanelist/resda-back.svg"
						alt=""
					/>
				</section>
			</div>
			<div v-else-if="!selected" class="resda-down-cont max-1825">
				<div class="resda-left-cont">
					<div class="resda-scroll-2">
						<div class="resda-red-txt d-flex align-items-center gap-2">
							<img
								src="../../assets/newdesign/BecomePanelist/application-rej.svg"
								alt=""
							/>Application rejected!
						</div>
						<div class="resda-black-txt text-darkgrey fam-lato">
							{{
								InstructorData[0].instructorInfo.activity.find(
									(a) => a.status === 0
								)?.remarks
							}}
						</div>
						<div>
							<div class="resda-top">VISIT US BACK ON</div>
							<div class="resda-bottom">{{ formattedRejoinDate }}</div>
						</div>
					</div>
					<b-button
						@click="goToInstructor()"
						id="hideinmobile"
						class="candash-addBtn mt-3 w-50"
						>{{ buttonText }}</b-button
					>
				</div>
				<section class="resda-back-img-size-2">
					<img
						class="w-100"
						src="../../assets/newdesign/BecomePanelist/application-rej-back.svg"
						alt=""
					/>
				</section>
			</div>
			<!-- <div v-else class="resda-down-cont max-1825">
				<Spinner :id="'streak'" class="w-100"></Spinner>
			</div> -->
			<footer id="hideinlaptop">
				<b-button
					@click="goToInstructor()"
					v-if="!selected"
					class="candash-addBtn w-100"
					>{{ buttonText }}</b-button
				>
				<b-button
					@click="goToDashboard()"
					v-if="selected"
					class="candash-addBtn w-100"
					>Go to dashboard</b-button
				>
			</footer>
		</main>
		<b-modal
			id="notSupported"
			hide-header
			hide-footer
			hide-header-close
			size="sm"
			centered
		>
			<div class="d-flex flex-column justify-content-center align-items-center">
				<img
					src="@/assets/New Profile/warning-icon-small.svg"
					alt="Warning icon"
				/>
				<h5 class="text-center mt-3">Not supported on mobile.</h5>
				<p class="text-center mt-2 px-3">
					Please access this feature using a desktop browser for the best
					experience.
				</p>
				<b-button
					@click="$bvModal.hide('notSupported')"
					class="candash-addBtn mt-3"
				>
					Close
				</b-button>
			</div>
		</b-modal>
	</div>
</template>

<script>
import { mapGetters } from "vuex";
import { postInstructorInformation } from "@/utils/apiFunctions";
import router from "@/router";
export default {
	name: "BecomeInstructor",
	data() {
		return {
			InstructorData: [],
			selected: false,
			buttonText: "Apply",
			rejoinInstructorDate: "2025-08-28T09:54:39.692000",
		};
	},
	created() {
		this.instructorStatus();
	},
	computed: {
		...mapGetters("userVUEX", {
			userInfo: "getUserInfo",
		}), // 👈 getter from your store

		formattedRejoinDate() {
			const activity = this.InstructorData?.[0]?.instructorInfo?.activity;
			const rej = activity?.find((a) => a.status === 0);
			if (!rej?.rejoinInstructorDate) return "—";

			// Take API date and add 5 hr 30 min
			const targetDate = new Date(rej.rejoinInstructorDate);
			targetDate.setMinutes(targetDate.getMinutes() + 330); // 5 hr 30 min = 330 mins

			const now = new Date();

			const diffMs = targetDate - now;
			if (diffMs <= 0) return "Available now";

			const diffHrs = diffMs / (1000 * 60 * 60);

			if (diffHrs < 24) {
				const hrs = Math.floor(diffMs / (1000 * 60 * 60));
				const mins = Math.floor((diffMs % (1000 * 60 * 60)) / (1000 * 60));
				return `${hrs} hrs ${mins} min`;
			} else {
				return this.formatAsDayMonthYear(targetDate);
			}
		},
	},
	methods: {
		goToDashboard(){
			const mobile = window.innerWidth < 1024 ? true : false;
			if (mobile) {
				this.$bvModal.show("notSupported");
			}else{
				window.open("https://trainingadmin.hire3x.com/?from=candidate")
			}
		},
		updateButtonText() {
			const activity = this.InstructorData?.[0]?.instructorInfo?.activity;
			const rej = activity?.find((a) => a.status === 0);
			if (!rej?.rejoinInstructorDate) return;

			const targetDate = new Date(rej.rejoinInstructorDate);
			targetDate.setMinutes(targetDate.getMinutes() + 330); // Convert to IST

			const now = new Date();

			if (now < targetDate) {
				this.buttonText = "Go Back";
			} else {
				this.buttonText = "Apply";
			}
		},
		goToInstructor() {
			const activity = this.InstructorData?.[0]?.instructorInfo?.activity;
			const rej = activity?.find((a) => a.status === 0);
			if (!rej?.rejoinInstructorDate) return;

			const targetDate = new Date(rej.rejoinInstructorDate);
			targetDate.setMinutes(targetDate.getMinutes() + 330);

			const now = new Date();

			if (now < targetDate) {
				this.$router.go(-1);
			} else {
				this.$router.push({
					name: "BecomeInstructor",
				});
			}
		},

		formatAsDayMonthYear(dateObj) {
			const day = String(dateObj.getDate()).padStart(2, "0");
			const month = dateObj
				.toLocaleString("en-GB", { month: "long" })
				.toUpperCase();
			const year = dateObj.getFullYear();
			return `${day} ${month} ${year}`;
		},
		async instructorStatus() {
			try {
				let payload = {
					email: this.userInfo.email,
				};

				const response = await postInstructorInformation(payload);
				if (response.status === 200) {
					this.InstructorData = response.data.data.data;
					if (this.InstructorData[0].instructorInfo.status === 1) {
						this.selected = true;
					}
					this.updateButtonText();
				}
			} catch (error) {
				console.error("API error:", error);
			}
		},
	},
};
</script>

<style>
.resda-main-container {
	background-color: #e9ecef;
	height: calc(100vh - 60px);
	padding: 15px 15px 15px 75px;
	top: 60px;
	position: relative;
	display: flex;
	flex-direction: column;
	align-items: center;
}
.resda-down-cont {
	height: calc(100vh - 100px);
	overflow: auto;
	border-radius: 8px;
	background-color: #f0f5ff;
	border: 1px solid #8c8c8c54;
	box-shadow: 0px 4px 8px 0px #0000002b;
	display: flex;
	justify-content: space-between;
}

.resda-back-img-size {
	height: calc(100vh - 151px);
}
.resda-back-img-size-2 {
	/* height: calc(100vh - 151px); */
	width: 40%;
	display: flex;
	align-items: flex-end;
}
.resda-left-cont {
	padding: 10px 30px;
	width: 55%;
	display: flex;
	flex-direction: column;
	gap: 20px;
	height: calc(100vh - 185px);
	margin-top: 20px;
	overflow: auto;
}
.resda-left-cont::-webkit-scrollbar-track {
	background: transparent;
	border-radius: 15px;
}
.resda-left-cont::-webkit-scrollbar-thumb {
	box-shadow: none;
}

.resda-fs-32 {
	font-size: 32px;
}

.resda-fs-20 {
	font-size: 20px;
}
.resda-qual-skill {
	box-shadow: 0px 1px 2px 0px #1018280d;
	background: linear-gradient(
		90deg,
		rgba(255, 221, 128, 0.8) -19.68%,
		rgba(240, 245, 255, 0.8) 100%
	);
	display: flex;
	align-items: center;
	justify-content: space-between;
	font-size: 16px;
	font-family: "lato", sans-serif;
	padding: 6px 10px;
	border-radius: 4px;
}
.resda-greentxt {
	font-style: italic;
	font-weight: 700;
	color: #009045;
}
.resda-scroll-2 {
	display: flex;
	flex-direction: column;
	gap: 20px;
	height: calc(100vh - 274px);
	overflow: auto;
}
.resda-scroll {
	min-height: 150px;
	height: calc(100vh - 464px);
	overflow: auto;
}
.resda-scroll .wrapper-scroll {
	display: flex;
	flex-wrap: wrap;
	gap: 20px;
}
.resda-card-svg {
	position: absolute;
	right: 10px;
	top: 10px;
}
.resda-red-txt {
	font-family: "Montserrat", sans-serif;
	font-size: 32px;
	font-weight: 600;
	color: #ad1927;
}
.resda-black-txt {
	font-size: 20px;
	font-weight: 400;
}
.resda-top {
	border-radius: 12px 12px 0px 0px;
	border: 1px solid #e0e0e0;
	background-color: #ffffff;
	display: flex;
	align-items: center;
	justify-content: center;
	padding-block: 15px;
	font-family: "Inter", sans-serif;
	font-size: 16px;
	font-weight: 600;
	letter-spacing: 0.1em;
	color: #213a5f;
}
.resda-bottom {
	border-radius: 0px 0px 12px 12px;
	background-color: #cae2fc;
	display: flex;
	align-items: center;
	justify-content: center;
	padding-block: 10px;
	font-family: "Inter", sans-serif;
	font-size: 24px;
	font-weight: 900;
	letter-spacing: 0.1em;
	color: #1a4164;
}

.max-wid-85 {
	max-width: 85%;
}
.resda-scroll article {
	background-color: #fff;
	border-radius: 4px;
	padding: 3px 8px;
	font-family: "Montserrat", sans-serif;
	font-weight: 500;
	font-size: 16px;
	color: #20639b;
}
@media only screen and (max-width: 1028px) {
	.resda-scroll article {
		font-size: 14px;
	}
	.resda-main-container {
		background-color: #e9ecef;
		height: calc(
			100dvh - (60px + env(safe-area-inset-top) + env(safe-area-inset-bottom))
		);
		padding: 0px;
		overflow: auto;
		/* position: fixed; */
		top: unset;
		display: block;
	}
	.resda-down-cont {
		height: 92%;
		border-radius: 0px;
		background-color: #e9ecef;
		border: none;
		box-shadow: none;
	}
	.resda-left-cont {
		padding: 15px;
		width: 100%;
		display: flex;
		flex-direction: column;
		gap: 20px;
		height: 100%;
		margin-top: unset;
		overflow: auto;
		position: relative;
	}
	.resda-main-container footer {
		background-color: #f9fafb;
		height: 8%;
		padding-inline: 15px;
		display: flex;
		align-items: center;
	}
	.resda-back-img-size {
		height: unset;
		position: absolute;
		right: 0px;
		top: 0px;
		width: 40%;
	}
	.resda-fs-32 {
		font-size: 18px;
		min-width: 211px;
		width: 60%;
	}
	.resda-fs-20 {
		font-size: 14px;
		width: 65%;
	}
	.resda-qual-skill {
		font-size: 14px;
	}
	.resda-scroll {
		min-height: unset;
		height: unset;
		overflow: unset;
	}
	.resda-card-svg {
		position: absolute;
		right: 5px;
		top: 5px;
	}
	.resda-red-txt {
		font-size: 18px;
	}
	.resda-black-txt {
		font-size: 13px;
		font-weight: 500;
	}
	.resda-top {
		background-color: #f4f6f7;
		font-size: 14px;
		position: relative;
		z-index: 2;
	}
	.resda-bottom {
		font-size: 18px;
		position: relative;
		z-index: 2;
	}
	.resda-back-img-size-2 {
		height: unset;
		display: unset;
		position: absolute;
		bottom: 8%;
		width: 100%;
		z-index: 1;
	}
}
@media (min-width: 500px) and (max-width: 1025px) {
	.resda-back-img-size {
		height: 130px;
		width: unset;
	}
	.resda-back-img-size-2 {
		height: unset;
		display: unset;
		position: absolute;
		bottom: 8%;
		right: 0;
		width: 70%;
		z-index: 1;
	}
}
</style>
